import AppButton from "components/AppButton/AppButton";
import ContainerFlex, { PrintableBodyWrapper } from "components/ContainerFlex";
import useApi, { ApiMethod } from "hooks/useApi";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { RouteNames } from "routes/routes";
import Endpoints from "services/api/endpoints";
import { showMessage } from "utils/messages";
import { getItemLocalStore } from "utils/storeUtils";
import { LOCAL_STORE_CLIENTE } from "../../../constants";

import { hiddenCardNumberTwo, moneyMask } from "utils/mask";
import * as St from "./styles";

import {
  FaturaImpressaoType,
  GrupoLancamentoImpressaoType,
  LancamentoImpressaoType,
} from "models/cartao";
import {
  InvoiceInstallmentCalculationType,
  PaymentInvoiceType,
} from "models/cliente";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import {
  addFaturaList,
  addInstallmentPaymentInvoice,
  addInvoiceInstallmentCalculation,
  addPaymentInvoice,
  addValuePaymentInvoice,
} from "redux/features/cliente/cliente-slice";
import { addTypeFlowState } from "redux/features/security/security-slice";
import { ClientStatus } from "utils/clientStatus";

const Fatura = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { cpf, nome, dadosLogin, statusCliente } =
    getItemLocalStore(LOCAL_STORE_CLIENTE);

  const { negotiatePage, typeFlow } = useAppSelector((state) => state.security);

  const [fatura, setFatura] = useState<FaturaImpressaoType | null>(null);
  const [faturaFallback, setFaturaFallback] = useState<any>(null);
  const [faturaList, setFaturaList] = useState<any>(null);

  const [lancamentos, setLancamentos] = useState<
    GrupoLancamentoImpressaoType[]
  >([]);
  const [dadosFatura, setDadosFatura] = useState<FaturaImpressaoType>();
  const idFatura = useRef();
  const [availableInstallments, setAvailableInstallments] = useState(false);

  const getListFaturaCliente = useApi<any>(
    Endpoints.relatorio.getInvoicePrint.replace(
      "PARAM_NRCARTAO",
      dadosLogin?.numeroCartaoTeucard,
    ),
    ApiMethod.GET,
  );

  const getListFaturaClienteFallback = useApi<any>(
    Endpoints.relatorio.getListaFaturas
      .replace("PARAM_CPF", cpf)
      .replace("PARAM_NRCARTAO", dadosLogin?.numeroCartaoTeucard)
      .replace("PARAM_TOKEN", dadosLogin?.tokenCartao)
      .replace("PARAM_TIPO", "PADRAO"),
    ApiMethod.GET,
  );

  useEffect(() => {
    dispatch(addInstallmentPaymentInvoice("1"));
    dispatch(
      addInvoiceInstallmentCalculation({} as InvoiceInstallmentCalculationType),
    );
    dispatch(addValuePaymentInvoice(""));
    dispatch(addTypeFlowState("fatura"));
  }, [dispatch]);

  useEffect(() => {
    if (faturaFallback?.listaFaturas?.[0]?.parcelamento) {
      setAvailableInstallments(true);
    }
  }, [faturaFallback]);

  const handleButton = () => {
    history.push({
      pathname: RouteNames.ESCOLHA_PAGAMENTO,
      state: { idFatura: idFatura.current },
    });
  };

  useEffect(() => {
    if (
      (statusCliente === ClientStatus.COBRANCA && negotiatePage) ||
      fatura?.statusFatura === "COBRANCA"
    ) {
      history.push(RouteNames.NEGOCIE);
    }
  }, [statusCliente, negotiatePage, history, fatura]);

  const getFaturaCliente = useApi<any>(
    Endpoints.autorizador.getFaturaAtualCliente,
    ApiMethod.POST,
  );

  const checkTypeOfInvoice = (lancamento: LancamentoImpressaoType) =>
    lancamento.tipo?.toUpperCase() === "ANUIDADE" ||
    Boolean(lancamento.descricao?.toUpperCase().includes("ANUIDADE"));

  const componentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({
    content: () => componentRef.current,
  });

  const getFaturas = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando dados da tua fatura aguarde..."));
    sessionStorage.setItem("@TeuCard:LimiteExtrato", "30");

    try {
      const response = await getListFaturaCliente.callApi();
      const responseFallback = await getListFaturaClienteFallback.callApi();
      if (response.status >= 200 && response.status < 300) {
        setFatura(response.data);
        setFaturaFallback(responseFallback.data);
        const responseFatura = await getFaturaCliente.callApi({
          numeroCartao: dadosLogin?.numeroCartaoTeucard || "",
        });
        dispatch(addFaturaList(responseFatura?.data));
        if (responseFatura.status >= 400) {
          dispatch(setLoading(false));
          const { mensagem } = responseFatura.data;
          showMessage("warning", "Atenção!", mensagem);
          history.push(RouteNames.HOME);
        }

        setFaturaList(responseFatura.data);
        idFatura.current = responseFatura.data?.data?.id; // idFatura do BD Mongo (BFF)

        dispatch(setLoading(false));
      } else {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        history.push(RouteNames.HOME);

        showMessage("warning", "Atenção!", mensagem);
      }
    } catch (error) {
      console.log("error catch fatura", error);
      history.push(RouteNames.HOME);

      showMessage(
        "warning",
        "Atenção!",
        (error as { mensagem?: string })?.mensagem ||
          "Houve um erro ao recuperar dados de fatura, tente novamente",
      );
    }
  };
  useEffect(() => {
    getFaturas();
    // getFaturas vem de useApi/e nao e memoizada; incluir causaria refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      const ultimaFatura = fatura;
      setDadosFatura(ultimaFatura as FaturaImpressaoType);
      dispatch(
        addPaymentInvoice({
          dataVencimento: ultimaFatura?.faturaVencimento,
          status: ultimaFatura?.statusFatura,
          statusDescricao: ultimaFatura?.statusFatura,
          valorMaximoRecebimento: ultimaFatura?.valorTotal,
          valorMinimoRecebido: ultimaFatura?.valorMinimo,
          numeroCartao: ultimaFatura?.numeroCartao,
          id_fatura: ultimaFatura?.id_fatura, // id_fatura autorizador
          id: ultimaFatura?.id, // id fatura mongo (BFF)
          cliente: {
            nome: ultimaFatura?.nome,
            cpf,
            saldoDisponivel: ultimaFatura?.limiteDisponivel,
          },
          lancamentos: ultimaFatura?.lancamentos,
        } as PaymentInvoiceType),
      );

      if (ultimaFatura?.lancamentos) {
        setLancamentos(grupoLancamento(ultimaFatura?.lancamentos));
      }
    } catch (error) {
      console.log(error);
    }
    // grupoLancamento e definida no corpo do componente (nao memoizada); incluir
    // causaria refetch/recalculo em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fatura, cpf, dispatch]);

  const clickVoltar = () => {};

  const hoje = new Date();
  const diaAtual = moment(hoje).format("DD/MM/YYYY");
  const grupoLancamento = (lancamentos: LancamentoImpressaoType[]) => {
    const groups = lancamentos.reduce(
      (
        agrupamento: Record<string, GrupoLancamentoImpressaoType>,
        lancamento,
      ) => {
        const estabelecimento = checkTypeOfInvoice(lancamento)
          ? ""
          : lancamento.estabelecimento || "";
        const chave = `${lancamento.data}|${estabelecimento}`;
        if (!agrupamento[chave]) {
          agrupamento[chave] = {
            data: lancamento.data,
            estabelecimento,
            lancamentos: [],
          };
        }
        agrupamento[chave].lancamentos.push(lancamento);
        return agrupamento;
      },
      {},
    );

    return Object.values(groups);
  };

  const goToInstallments = () => {};

  return (
    <ContainerFlex translate="no" className="notranslate">
      <St.TitleH1>Tua - Fatura</St.TitleH1>
      {fatura ? (
        <>
          <ContainerFlex row>
            <ContainerFlex>
              <ContainerFlex>
                <ContainerFlex padding={10}>
                  <ContainerFlex style={{ paddingLeft: "3rem" }}>
                    <St.SpanTitleInvoice>Saldo devedor</St.SpanTitleInvoice>
                    <ContainerFlex row>
                      <St.BiggerTextInvoice>
                        {moneyMask(faturaList?.data?.saldo_devedor)}
                      </St.BiggerTextInvoice>
                    </ContainerFlex>
                    <ContainerFlex row>
                      <St.SpanTitleInvoice>Fatura Atual:</St.SpanTitleInvoice>
                      <ContainerFlex row>
                        <St.SpanTextInvoiceBold>
                          {moneyMask(dadosFatura?.valorTotal)}
                        </St.SpanTextInvoiceBold>
                      </ContainerFlex>
                    </ContainerFlex>
                    <ContainerFlex row>
                      <St.SpanTitleInvoice>Vencimento: </St.SpanTitleInvoice>
                      <St.SpanTextInvoiceBold>
                        {moment(dadosFatura?.faturaVencimento).format(
                          "DD/MM/YYYY",
                        )}
                      </St.SpanTextInvoiceBold>
                    </ContainerFlex>
                    <ContainerFlex row>
                      <St.SpanTitleInvoice>
                        Melhor dia para compra:{" "}
                      </St.SpanTitleInvoice>
                      <St.SpanTextInvoiceBold>
                        {faturaList?.data.melhor_dia_compra}
                      </St.SpanTextInvoiceBold>
                    </ContainerFlex>
                    <ContainerFlex row>
                      <St.SpanTitleInvoice>
                        Status da fatura:{" "}
                      </St.SpanTitleInvoice>
                      <St.SpanTextInvoiceBold>
                        {dadosFatura?.statusFatura === "PAGA" ||
                        dadosFatura?.statusFatura === "PAGA_COBMAIS"
                          ? "Fatura já paga"
                          : dadosFatura?.statusFatura ||
                            faturaList?.data.status}
                      </St.SpanTextInvoiceBold>
                    </ContainerFlex>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>
            {faturaList?.data.melhor_dia_compra === moment().format("DD") ? (
              <></>
            ) : (
              <ContainerFlex center>
                <ContainerFlex center padding={25}>
                  <ContainerFlex
                    padding={15}
                    color="#fbfbfb"
                    width={100}
                    height={50}
                    maxWidth={200}
                    maxHeight={350}
                    scroll
                    hidden
                  >
                    <PrintableBodyWrapper
                      ref={componentRef}
                      lang="pt-BR"
                      translate="no"
                      className="notranslate"
                    >
                      <St.ReceiptWrapper>
                        {/* Header */}
                        <St.ReceiptHeader>
                          <St.ReceiptTitle>
                            Fatura Resumida TeuCard
                          </St.ReceiptTitle>
                          <St.ReceiptDate>Data: {diaAtual}</St.ReceiptDate>
                        </St.ReceiptHeader>

                        {/* Client info */}
                        <St.ReceiptClientRow>
                          <St.ReceiptClientCol>
                            <St.ReceiptLabel>Cliente:</St.ReceiptLabel>
                            <St.ReceiptValue style={{ textAlign: "left" }}>
                              {dadosFatura?.nome ?? nome}
                            </St.ReceiptValue>
                          </St.ReceiptClientCol>
                          <St.ReceiptClientCol
                            style={{ alignItems: "flex-end" }}
                          >
                            <St.ReceiptLabel>Cartão:</St.ReceiptLabel>
                            <St.ReceiptValue>
                              {hiddenCardNumberTwo(
                                dadosFatura?.numeroCartao ??
                                  dadosLogin?.numeroCartaoTeucard,
                                4,
                                12,
                                ".****.****.",
                              )}
                            </St.ReceiptValue>
                          </St.ReceiptClientCol>
                        </St.ReceiptClientRow>

                        {/* <St.ReceiptDivider /> */}

                        {/* Credit limit section */}
                        <St.ReceiptSectionTitle>
                          Limites Disponíveis R$
                        </St.ReceiptSectionTitle>
                        <St.ReceiptRow>
                          <St.ReceiptValue style={{ textAlign: "left" }}>
                            Limite de compras:
                          </St.ReceiptValue>
                          <St.ReceiptValue>
                            {fatura &&
                              moneyMask(dadosFatura?.limiteCompraDisponivel)}
                          </St.ReceiptValue>
                        </St.ReceiptRow>
                        <St.ReceiptRow>
                          <St.ReceiptValue style={{ textAlign: "left" }}>
                            Limite de empréstimo:
                          </St.ReceiptValue>
                          <St.ReceiptValue>
                            {fatura &&
                              moneyMask(dadosFatura?.limiteSaqueDisponivel)}
                          </St.ReceiptValue>
                        </St.ReceiptRow>
                        <St.ReceiptRow>
                          <St.ReceiptValue style={{ textAlign: "left" }}>
                            Limite Extra 12x:
                          </St.ReceiptValue>
                          <St.ReceiptValue>
                            {fatura &&
                              moneyMask(dadosFatura?.limite12xDisponivel)}
                          </St.ReceiptValue>
                        </St.ReceiptRow>
                        {/* <St.ReceiptRow>
                          <span>
                            <St.ReceiptLabel>Limite disponível R$ </St.ReceiptLabel>
                          </span>
                          <St.ReceiptValue>
                            {dadosFatura?.limiteDisponivel != null &&
                              moneyMask(dadosFatura?.limiteDisponivel)}
                          </St.ReceiptValue>
                        </St.ReceiptRow> */}

                          {statusCliente === "INADIMPLENTE" && (
                            <St.ReceiptLabel
                              style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}
                            >
                              Possui fatura em atraso
                            </St.ReceiptLabel>
                          )}

                        {statusCliente === "INADIMPLENTE" && (
                          <St.ReceiptLabel
                            style={{
                              color: "red",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            Possui fatura em atraso
                          </St.ReceiptLabel>
                        )}

                        <St.ReceiptDivider />

                        {/* Transactions */}
                        <St.ReceiptSectionTitle>
                          Lançamentos:
                        </St.ReceiptSectionTitle>
                        {lancamentos.map((grupoLancamento) => {
                          const chaveGrupo = `${grupoLancamento.data}|${grupoLancamento.estabelecimento}`;
                          return (
                            <div
                              style={{ marginBottom: "3mm" }}
                              key={chaveGrupo}
                            >
                              <St.ReceiptDateGroup>
                                <span>
                                  {moment(grupoLancamento.data).format(
                                    "DD/MM/YYYY",
                                  )}
                                </span>
                                {grupoLancamento.estabelecimento && (
                                  <span>{grupoLancamento.estabelecimento}</span>
                                )}
                              </St.ReceiptDateGroup>
                              {grupoLancamento.lancamentos.map(
                                (lancamento, index) => {
                                  const isCredito =
                                    lancamento.debitoCredito?.toUpperCase() ===
                                    "CREDITO";
                                  const isParcelamentoFatura =
                                    lancamento.tipo === "PARCELAMENTO_FATURA";
                                  const isPagamentoFatura =
                                    lancamento.tipo === "PAGAMENTO_FATURA";
                                  return (
                                    <St.ReceiptTransaction
                                      key={`${chaveGrupo}|${index}`}
                                    >
                                      <St.ReceiptTransactionDesc>
                                        {isParcelamentoFatura ||
                                        isPagamentoFatura
                                          ? lancamento.tipo
                                          : lancamento.descricao}
                                        {lancamento.quantidadeParcelas &&
                                          lancamento.quantidadeParcelas > 1 &&
                                          ` - Parc ${lancamento.parcelaAtual}/${lancamento.quantidadeParcelas}`}
                                      </St.ReceiptTransactionDesc>
                                      <St.ReceiptTransactionValue>
                                        {isCredito
                                          ? `-${moneyMask(lancamento.valor)}`
                                          : moneyMask(lancamento.valor)}
                                      </St.ReceiptTransactionValue>
                                    </St.ReceiptTransaction>
                                  );
                                },
                              )}
                            </div>
                          );
                        })}

                        <St.ReceiptDivider />

                        {/* Invoice footer */}
                        <St.ReceiptRow>
                          <St.ReceiptLabel style={{ fontWeight: "bold" }}>
                            Fatura Vencimento -{" "}
                            {moment(dadosFatura?.faturaVencimento).format(
                              "DD/MM/YYYY",
                            )}
                          </St.ReceiptLabel>
                        </St.ReceiptRow>
                        <St.ReceiptStatusRow>
                          Status da fatura: {dadosFatura?.statusFatura}
                        </St.ReceiptStatusRow>
                        <St.ReceiptFooterRow>
                          <St.ReceiptLabel>Valor total</St.ReceiptLabel>
                          <St.ReceiptValue>
                            {moneyMask(dadosFatura?.valorTotal)}
                          </St.ReceiptValue>
                        </St.ReceiptFooterRow>
                        <St.ReceiptFooterRow>
                          <St.ReceiptLabel>Valor mínimo</St.ReceiptLabel>
                          <St.ReceiptValue>
                            {moneyMask(dadosFatura?.valorMinimo)}
                          </St.ReceiptValue>
                        </St.ReceiptFooterRow>

                        {dadosFatura?.parcelamento && (
                          <>
                            <St.ReceiptDivider />
                            <St.ReceiptValue
                              style={{ display: "block", fontSize: "9px" }}
                            >
                              Se preferir, você pode ativar o parcelamento da
                              tua fatura. Procure um operador(a) TeuCard para
                              mais informações!
                            </St.ReceiptValue>
                          </>
                        )}
                      </St.ReceiptWrapper>
                    </PrintableBodyWrapper>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            )}
          </ContainerFlex>
        </>
      ) : (
        <ContainerFlex row>
          <ContainerFlex center align="center">
            <St.TextParagraph>
              Desculpe! <br /> Você não possui fatura no momento.
            </St.TextParagraph>
          </ContainerFlex>
        </ContainerFlex>
      )}

      <ContainerFlex gap={"8px"} center horizontal row space>
        <AppButton
          content="Voltar"
          route={
            typeFlow === "fatura"
              ? RouteNames.HOME
              : RouteNames.ATENDIMENTO_HOME
          }
          outlined={true}
          click={clickVoltar}
          hidden={false}
        />
        {fatura &&
        dadosFatura?.statusFatura !== "PAGA" &&
        dadosFatura?.statusFatura !== "PAGA_COBMAIS" ? (
          <AppButton
            content="Pagar"
            outlined={true}
            click={handleButton}
            hidden={false}
          />
        ) : null}

        {availableInstallments && (
          <AppButton
            content="Parcelamento"
            outlined={true}
            click={goToInstallments}
            route={RouteNames.PARCELAS_FATURA}
            hidden={false}
          />
        )}

        {fatura ? (
          <button onClick={reactToPrintFn} className="normal">
            Imprimir
          </button>
        ) : null}
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default Fatura;
